document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('#header-component');
  if (!header) return;

  document.documentElement.classList.add('custom-header-loaded');

  const onScroll = () => {
    if (window.scrollY > 10) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const accountButtons = document.querySelectorAll('.account-button');

  accountButtons.forEach((button) => {
    const rect = button.getBoundingClientRect();
    const isVisible =
      rect.width > 0 &&
      rect.height > 0 &&
      getComputedStyle(button).display !== 'none';

    if (!isVisible) return;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const container = button.closest('anchored-popover-component');
      const popover = container?.querySelector('[popover]');

      if (!popover) return;

      try {
        if (popover.matches(':popover-open')) {
          popover.hidePopover();
        } else {
          popover.showPopover();
        }
      } catch (err) {
        console.error('Account popover toggle failed:', err);
      }
    });
  });
});